import { useAppBrand } from '@composables/tools/app-brand.hook'

import { show404 } from '@utils/pages/error'

import { defineNuxtRouteMiddleware, navigateTo } from '#app'

export default defineNuxtRouteMiddleware((to) => {
  const { isSmartestMinds } = useAppBrand()

  if (isSmartestMinds) return navigateTo('/')

  if (!Number(to.params.summarize)) return show404()
})
